exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pic_template[data-v-5d2c8ab5] {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  /* width: 100%; */\n}\n.pic_template img[data-v-5d2c8ab5] {\r\n  cursor: move;\r\n  width: 100%;\r\n  -moz-user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\n}\r\n", ""]);

// exports
